import { Icon, Msg } from "@shared/components";

export const FairnessCompleteStep = () => {
  return (
    <div className="code-editor-exam-detail__fairness-complete">
      <Icon
        type=""
        className="code-editor-exam-detail__fairness-complete__icon"
        iconClassName="code-editor-exam-detail__fairness-complete__icon code-c-icon__green-tick"
      />
      <div className="code-editor-exam-detail__fairness-complete__title-container">
        <Msg
          className="code-editor-exam-detail__fairness-complete__title"
          id="editor-exam-details.modals.fairnessComplete.title"
        />
      </div>
      <div>
        <Msg id="editor-exam-details.modals.fairnessComplete.text" />
      </div>
    </div>
  );
};
